import script from "./GaugeComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GaugeComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GaugeComponent.vue?vue&type=style&index=0&id=7f6ad386&lang=css"

const __exports__ = script;

export default __exports__